import { useActorRef } from '@xstate/react';

import { customizationMachine } from './customization.machine';
import { useFetchCustomizationDataActor } from './hooks';
import { type Input } from './types';

import type { MachineImplementationsFrom } from 'xstate';
import type { GuardPredicate } from 'xstate/guards';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Initializes and provides a reference to a customization state machine actor.
 */
export const useInitCustomizationMachine = (input: Input, implementations?: Implementations) => {
  const fetchCustomizationData = useFetchCustomizationDataActor();

  // ─── Actor ───────────────────────────────────────────────────────────

  const actorRef = useActorRef(
    customizationMachine.provide({
      ...implementations,
      actors: {
        ...implementations?.actors,
        fetchCustomizationData,
      },
      guards: {
        ...implementations?.guards,
      },
    }),
    { input },
  );

  // ─────────────────────────────────────────────────────────────────────

  return actorRef;
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Implementations = MachineImplementationsFrom<typeof customizationMachine>;
